import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect, useState } from 'react'
import { reportService } from '../services/reportService'
import { ReportSupportsParams } from '../services/reportService/reportSupports'

export const useReportSupports = () => {
  const [params, setParams] = useState<ReportSupportsParams | undefined>({})
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['reportSupports', params],
    queryFn: async () => reportService.reportSupports(params),
    placeholderData: keepPreviousData,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
  }
}
